/* eslint-disable import/no-anonymous-default-export */
import {
  CREATESHIIPING,
  DELETESHIPPING,
  FETCHALLSHIPPINGS,
  FETCHSHIIPING,
  UPDATESHIIPING,
} from "../constants/actionTypes";

export default (shipping = {}, action) => {
  switch (action.type) {
    case DELETESHIPPING:
      return shipping._id !== action?._id;
    case CREATESHIIPING:
      return [action.payload];
    case UPDATESHIIPING:
      return shipping?._id === action?.payload._id ? action?.payload : shipping;
    case FETCHALLSHIPPINGS:
      return action.payload;
    case FETCHSHIIPING:
      return action.payload;
    default:
      return shipping;
  }
};
